import { Component, Input } from '@angular/core';
import { Subject } from "rxjs";
import { PlanPreventionEntity } from '../../entities/plan-prevention.entity';
import { PdpSearchCriteria } from '../../entities/plan-prevention-search-criteria';

@Component({
	selector: 'plan-preventions',
	templateUrl: 'gestion-plan-prevention.html',
	styleUrls: ['gestion-plan-prevention.css']
})
export class GestionPlanPreventionsComponent {
	
	@Input() refreshPdPCommand!: Subject<void>;

	view: string = 'list';
	editCommands: Subject<PlanPreventionEntity> = new Subject<PlanPreventionEntity>();
	searchListCommands: Subject<PdpSearchCriteria> = new Subject<PdpSearchCriteria>();
	initListCommands: Subject<void> = new Subject<void>();
	
	constructor() {
	}
	
	editThisPdp(pdp: PlanPreventionEntity){
		this.changeView('stepper');
		this.editCommands.next(pdp);
	}
	
	changeView(view: string) {
		this.initListCommands.next();
		this.view = view;
	}
	
	filterResults(searchCriteria: PdpSearchCriteria) {
		this.searchListCommands.next(searchCriteria);
	}
}